<template>
	<div class="order">
		<div class="wrap container1">
			<div class="header">
				<div class="link">
					<router-link class="link" :to="{name: 'orders'}">
						<div class="icon" v-html="require('@/assets/icons/long-arrow-left.svg')"/>
						Tilbage til oversigt
					</router-link>
				</div>

				<div class="title" v-if="data">
					Ordrenummer #{{data.number}}
				</div>
			</div>

			<orderlist v-if="data" v-bind="{data, products, type: 'order'}"/>
		</div>
	</div>
</template>

<script>
import orderlist from "@/components/orderlist/index.vue";
import {products} from "@/modules/utils";

export default {
	components: {orderlist},
	data() {
		return {
			data: null
		}
	},
	computed: {
		cartId: (t) => t.$route.params.id,
		products: (t) => products({items: t.data.line_items})
	},
	methods: {
		async getData() {
			const {data: {data}} = await this.$store.dispatch("cart/getOrder", {cartId: this.cartId});
			this.data = data;
		}
	},
	async created() {
		await this.getData();
		this.$store.dispatch("base/meta", {title: `#${this.data.number}`});
	}
};
</script>

<style lang="scss" scoped>
.order {
	.wrap {
		.header {
			.link {
				margin-bottom: 30px;
				display: flex;
				align-items: center;
				color: #007ACE;
				font-size: 14px;

				.icon {
					display: inline-flex;
					margin-right: 0.5em;
					margin-bottom: -1px;

					/deep/ svg {
						$s: 14px;
						width: $s;
						height: $s;

						path {
							fill: #007ACE;
						}
					}
				}
			}

			.title {
				font-size: 24px;
				font-weight: 500;
			}
		}
	}
}
</style>
